import { ApolloClient, InMemoryCache } from '@apollo/client';
import link from './link';

const client = new ApolloClient({
  link: link.authLink.concat(link.httpLink),
  cache: new InMemoryCache(),
});

export default client;
